     import { createSlice } from '@reduxjs/toolkit'
import { requests } from "api/index";
import URLS from "api/endPoints";

// Slice

const initialUser = {ProfileDataSave:"",}
   

const slice = createSlice({
  name: 'profiler',
  initialState: {
    declaration: initialUser,
  },
  reducers: {
  
    
    postProfileDataSaveReducer: (state, action) => {
      state.declaration.ProfileDataSave = action.payload
    },
  
 
  },
});

export default slice.reducer

// Actions

const { postProfileDataSaveReducer} = slice.actions

export const postProfileDataSaveAction = (payload) => async dispatch => {

    try {
      let response = await requests.postHC("career/ProfileDataSave?Candidateno=" + payload.CandidateNo,payload.data)
      await dispatch(postProfileDataSaveReducer(response))
      return returnCode(response)

    } catch (error) {
      return console.error(error.message);
    }
  }



function returnCode(response) {
    if (response.ResponseCode == 100 || 200) {
      return response;
    } else if (response.ResponseCode == 103) {
      return 103;
    } else {
      return 101;
    }
  }
